module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c6a089bb8f98380b457b573b7ce4a187.png";